/**
 * 模态动作定义
 * @author chenqunfeng
 * @since 17/10/21
 */

import { SHOW_MODAL, HIDE_MODAL } from 'constants/action.json5';

export const showModal = data => {
  return {
    type: SHOW_MODAL,
    modalType: data.modalType,
    modalProps: data.modalProps,
  };
};

export const hideModal = data => {
  return {
    type: HIDE_MODAL,
    modalType: data.modalType,
    modalProps: data.modalProps,
  };
};
